<template>
  <div>
    <div class="mb-3">
      <div class="mb-2">Tiêu đề</div>
      <el-input placeholder="Nhập tiêu đề để dễ nhớ hơn." v-model="title"></el-input>
    </div>
    <div class="mb-3">
      <div class="mb-2">Nội dung <span class="zalo-text-danger">*</span></div>
      <el-input disabled
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 6}"
                placeholder="Nhập nội dung công việc"
                v-model="content">
      </el-input>
    </div>
    <div v-if="showDestination" class="mb-3">
      <div class="mb-2">Giao cho <span class="zalo-text-danger">*</span></div>
      <el-select :disabled="disableDestionation" class="w-100 " filterable
                 v-model="listAssgineeValue"
                 multiple
                 collapse-tags
                 placeholder="Bản thân">
        <el-option
          v-for="item in listOptions"
          :key="item.uid"
          :label="item.displayName"
          :value="item.uid">
          <div class="d-flex align-items-center">
            <el-avatar :size="24" :src="item.avatar" />
            <div class="ms-2">{{ item.displayName }}</div>
          </div>
        </el-option>
      </el-select>
    </div>
    <div class="mb-3 d-flex flex-column">
      <div class="mb-2 ">Thời hạn</div>
      <el-date-picker class="w-100"
                      v-model="dueDate"
                      type="datetime"
                      placeholder="Không thời hạn"
                      default-time="12:00:00"
      >
      </el-date-picker>
      <div class="mb-3" />
    </div>

    <div class="mt-3 d-flex justify-content-end">
      <el-button type="danger" @click="closeDialog()">Hủy</el-button>
      <el-button :disabled="isDisabled" @click="save()" type="primary">Chỉnh sửa</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditTodo",
  props: {
    membersTodo: {
      type: Array
    },
    accountSelected: {
      type: Object
    },
    item: {
      type: Object
    },
    members: {
      type: Array
    }
  },
  data() {
    return {
      showDestination: true,
      disableDestionation: false,
      title: "",
      content: "",
      listAssgineeValue: [],
      dueDate: "",
      data: {}
    };
  },

  computed: {

    isDisabled() {
      let isDueDateMatch;
      if (this.dueDate === -1 || this.dueDate == "" || this.dueDate == null) {
        isDueDateMatch = false;
      } else isDueDateMatch = new Date(this.dueDate).getTime() <= new Date().getTime();
      return this.listAssgineeValue.length === 0 || isDueDateMatch;

    },
    listOptions() {

      if (this.members && this.members.length > 0) {
        if (this.item) {
          let datas = [];
          this.item.assignees.forEach(s => {
            let item = this.members.find(c => c.id == s.userId);
            if (item) {
              item.uid = item.id;
              item.displayName = item.name;
              datas.push(item);
            }
          });
          return datas;
        }
      }
      if (this.membersTodo) {
        if (this.item && this.item.extra.isGroup === true) {
          let datas = [];
          let itemDatas = JSON.parse(JSON.stringify(this.app.listContactsAccount));
          itemDatas.unshift({
            uid: this.accountSelected.accountId,
            displayName: this.accountSelected.displayName,
            avatar: this.accountSelected.avatar
          });
          itemDatas.forEach(s => {
            let item = this.membersTodo.find(c => c.id == s.uid);
            if (item) {
              let item1 = JSON.parse(JSON.stringify(item));
              item1.uid = item.id;
              item1.displayName = item.name;
              datas.push(item1);
            }
          });
          return datas;
        }
      }

      let items = JSON.parse(JSON.stringify(this.app.listContactsAccount));
      items.unshift({ uid: this.accountSelected.accountId, displayName: this.accountSelected.displayName });
      if (this.item) {
        let datas = [];
        this.item.assignees.forEach(s => {
          let item = items.find(c => c.uid == s.userId);
          if (item) {
            datas.push(item);
          }
        });
        return datas;
      }
      return items;
    }
  },
  methods: {

    getDateDefaultType() {
      if (this.dueDate === null || this.dueDate === -1 || this.dueDate === "") {
        return 0;
      } else {
        return 5;
      }
    },
    getDueDate() {
      if (this.dueDate === null || this.dueDate === -1 || this.dueDate === "") {
        return -1;
      } else {
        return new Date(this.dueDate).getTime();
      }
    },
    sendMessage(toId) {
      let req = {
        message: this.content,
        accountId: this.accountSelected.accountId,
        toId: toId
      };
      return this.$http.post("/api/message/sms", req).then(s => {
        return s.data;
      });
    },

    async save() {
      let req = {
        accountId: this.accountSelected.accountId,
        id: this.data.id,
        content: this.data.content,
        status: 0,
        schedule: "null",
        creator: this.data.creator,
        watchers: "[]",
        dateDefaultType: this.getDateDefaultType(),
        description: this.title,
        dueDate: this.getDueDate(),
        extra: JSON.stringify(this.data.extra)
      };
      req.assignees = JSON.stringify(this.listAssgineeValue);
      this.$http.post("/api/todo/reject", req).then(s => {
        if (s.data.error_code === 0) {
          this.app.isShowTodoDetail = false;
          this.alert("success", "Lưu công việc thành công.");
          this.closeDialog();
          this.app.isShowTodoDetail = false;
          req.statusTodo = 0;
          this.$bus.$emit("updateTask", req);
        } else {
          this.alertError("Cập nhật công việc không thành công");
        }
      });

    },
    closeDialog() {
      this.$emit("closeDialog");
    }


  },
  mounted() {
    this.data = JSON.parse(JSON.stringify(this.item));
    this.title = this.data.description;
    this.content = this.data.content;
    if (this.members && this.members.length > 0) {
      this.data.assignees.forEach(s => {
        let item = this.members.find(c => c.id == s.userId);
        if (item) {
          this.listAssgineeValue.push(item.uid);
        }
      });

    } else {
      let items = JSON.parse(JSON.stringify(this.app.listContactsAccount));
      items.unshift({
        uid: this.accountSelected.accountId,
        displayName: this.accountSelected.displayName,
        avatar: this.accountSelected.avatar
      });
      this.data.assignees.forEach(s => {
        let item = items.find(c => c.uid == s.userId);
        if (item) {
          this.listAssgineeValue.push(item.uid);
        }
      });
      this.listAssgineeValue.forEach(s => {
        let item1 = this.app.listContactsAccount.find(l => l.uid === s && l.accountId === this.accountSelected.accountId);
        if (!item1 && s !== this.accountSelected.accountId) {
          const indexAssginees = this.listAssgineeValue.indexOf(s);
          if (indexAssginees > -1) {
            this.listAssgineeValue.splice(indexAssginees, 1);
          }
        }
      });
      if (this.membersTodo) {
        let items = JSON.parse(JSON.stringify(this.listAssgineeValue));
        items.forEach(s => {
          let item = this.membersTodo.find(m => m.id === s);
          if (!item) {
            this.listAssgineeValue.splice(this.listAssgineeValue.indexOf(s), 1);
          }
        });

      }
      if (!this.item.extra.isGroup) {
        this.disableDestionation = true;
        this.listAssgineeValue = [];
        this.listAssgineeValue = this.data.assignees.map(s => s.userId);
        let individual = this.listAssgineeValue.find(s => s !== this.accountSelected.accountId);
        if (individual) {
          if (!items.find(i => i.uid === individual)) {
            this.showDestination = false;
          }
        }
      }


    }

    if (this.data.dueDate === -1) {
      this.dueDate = "";
    } else {
      this.dueDate = this.data.dueDate;
    }
  }
};
</script>

<style scoped>

</style>